'use client'

import { Media } from '@/components/Media'
import RichText from '@/components/RichText'
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel'
import { cn } from '@/utilities/ui'
import { ChevronsRight } from 'lucide-react'
import { useState } from 'react'
import Image from 'next/image'

// ...existing imports...

export const FeatureBlock = (props: any) => {
  const { title, subtitle, features, image } = props
  const [activeIdx, setActiveIdx] = useState(0)

  return (
    <section className="container mx-auto px-6 py-6" aria-label="Features">
      <div className="flex flex-col-reverse md:flex-row gap-10">
        {/* Feature Detail */}
        <section className="relative flex-1 flex flex-col items-center" aria-label="Feature Detail">
          <header className="w-full mb-4">
            {features?.[activeIdx]?.title && (
              <RichText
                className="font-light text-black text-xl md:text-2xl lg:text-[28px] text-center tracking-[0] leading-6 md:leading-7 [font-family:'Open_Sans',Helvetica]"
                data={features[activeIdx].title}
                enableGutter={false}
                enableProse={true}
              />
            )}
          </header>
          {image && (
            <figure className="w-full">
              {image && (
                <Image
                  src={typeof image === 'string' ? image : image.url}
                  alt={
                    typeof features?.[activeIdx]?.title === 'string'
                      ? features[activeIdx].title
                      : 'Feature'
                  }
                  width={1200}
                  height={480}
                  className="w-full h-[30vh] rounded-xl object-cover mb-6"
                  priority
                />
              )}
            </figure>
          )}
          {features?.[activeIdx].description && (
            <RichText
              className=""
              data={features[activeIdx].description}
              enableGutter={false}
              enableProse={true}
            />
          )}
          <div className="mt-6 w-full">
            {features?.[activeIdx]?.featureImages?.length > 0 && (
              <Carousel aria-label="Feature Images Carousel">
                <CarouselContent>
                  {features?.[activeIdx].featureImages?.map((img: any, index: any) => (
                    <CarouselItem className="basis-1/2" key={index} role="listitem">
                      <figure>
                        <Media
                          resource={img?.image}
                          imgClassName="w-full h-[30vh] rounded-xl object-cover transition-transform duration-300 hover:scale-110"
                          fetchPriority="low"
                        />
                      </figure>
                    </CarouselItem>
                  ))}
                </CarouselContent>
              </Carousel>
            )}
          </div>
        </section>
        {/* Feature List */}
        <aside className="relative flex-1" aria-label="Feature List">
          <div className="relative border border-border rounded-[20px] p-[36px_20px_40px] md:p-[36px_40px_40px]">
            <header className="flex flex-col items-center justify-center">
              {title && (
                <RichText
                  className="font-light text-black text-xl md:text-2xl lg:text-[28px] text-center tracking-[0] leading-6 md:leading-7 [font-family:'Open_Sans',Helvetica] mb-2"
                  data={title}
                  enableGutter={false}
                  enableProse={true}
                />
              )}
              {subtitle && (
                <RichText
                  className="font-bold text-primary text-2xl md:text-4xl lg:text-[55px] text-center leading-8 md:leading-[60.5px] tracking-[0] [font-family:'Roboto_Condensed',Helvetica] px-4"
                  data={subtitle}
                  enableGutter={false}
                  enableProse={true}
                />
              )}
            </header>
            <ul
              className="
                flex flex-col gap-3 md:gap-0 overflow-x-auto md:overflow-visible
                w-full pb-2 md:pb-0
                snap-x md:snap-none
                "
              role="list"
            >
              {features.map((f: any, i: any) => (
                <li key={i} role="listitem" className="min-w-[220px] md:min-w-0 snap-start">
                  <button
                    type="button"
                    className={cn(
                      'relative flex items-center  gap-2 md:gap-[15px] text-[12px]  md:text-[16px] text-black font-bold bg-[#fff4f3] px-[22px] py-[17px] rounded-[20px] hover:bg-black group mt-4 w-full transition-colors',
                      i === activeIdx && 'bg-black text-white',
                    )}
                    onClick={() => setActiveIdx(i)}
                    aria-current={i === activeIdx}
                  >
                    <ChevronsRight className="group-hover:text-white" />
                    <div className="group-hover:text-white">
                      {f.title && (
                        <RichText
                          className=""
                          data={f.title}
                          enableGutter={false}
                          enableProse={true}
                        />
                      )}
                    </div>
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </aside>
      </div>
    </section>
  )
}
